import React, { useEffect, useMemo, useState } from 'react';
import useVideoPlayer from 'components/hook/useVideoPlayer';
import { PERCENT_MAP, registerTrackingEvents, sendTracking } from 'helpers';

const AdPlayer = ({ videoUrl, onReset, onClick, onVideoEnd, trackingEvents }) => {
    const {
        videoRef,
        isMuted,
        progress,
        updateProgress,
        toggleMute,
        resetPlayback,
        setOnConditionReached,
    } = useVideoPlayer(videoUrl, true, onVideoEnd);

    const [isShowControl, setIsShowControl] = useState(false);

    // 광고 시작 이벤트 URL 추출
    const startEventUrl = useMemo(
        () => trackingEvents.find((event) => event.attributes.event === 'start')?.value || '',
        [trackingEvents]
    );

    // onReset prop에 resetPlayback 전달
    useEffect(() => {
        if (onReset) {
            onReset(resetPlayback);
        }
    }, [onReset]);

    // 트래킹 이벤트 등록
    useEffect(() => {
        const percentEvents = trackingEvents.filter((event) => PERCENT_MAP[event.attributes.event]);
        const progressEvents = trackingEvents.filter((event) => event.attributes.event === 'progress');

        const removePercentListeners = registerTrackingEvents(
            percentEvents,
            setOnConditionReached,
            (event) => sendTracking(event.value)
        );

        const removeProgressListeners = registerTrackingEvents(
            progressEvents,
            setOnConditionReached,
            (event) => sendTracking(event.value)
        );

        const removeStartListener = setOnConditionReached(0, () => sendTracking(startEventUrl));

        return () => {
            removePercentListeners();
            removeProgressListeners();
            removeStartListener();
        };
    }, [setOnConditionReached, trackingEvents, startEventUrl]);

    // 음소거 버튼 클릭 핸들러
    const handleToggleMute = (e) => {
        e?.stopPropagation();
        toggleMute();
    };

    return (
        <div
            id="player"
            onMouseEnter={() => setIsShowControl(true)}
            onMouseLeave={() => setIsShowControl(false)}
        >
            <a href='javascript:void' onClick={(e) => e.preventDefault()}>
                {/* 비디오 태그 */}
                <video
                    ref={videoRef}
                    width="640"
                    height="360"
                    autoPlay
                    muted={isMuted}
                    onTimeUpdate={updateProgress}
                    controls={false} // custom controls 사용
                    onClick={onClick}
                />
                <div className="player_ctrlBox">
                    {
                        isShowControl && (
                            <div className="ctrlBox">
                                <button
                                    type="button"
                                    className={`sound ${isMuted ? 'mute' : ''}`}
                                    onClick={handleToggleMute}
                                >
                                    {isMuted ? '음소거' : '소리 켜기'}
                                </button>
                            </div>
                        )
                    }
                    <div className="progress_track">
                        <div className="watched" style={{ width: `${progress}%` }}></div>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default AdPlayer;